import { render } from "./PopoverEditSensor.vue?vue&type=template&id=7d2ed964"
import script from "./PopoverEditSensor.vue?vue&type=script&lang=js"
export * from "./PopoverEditSensor.vue?vue&type=script&lang=js"
script.render = render

export default script